import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLoaderData, useNavigation } from 'react-router-dom';

import { announceEmbedShown } from '@/utils/embed';

/*
 * /embed/mall 화면. 글로벌 소듀 관리자 안에 끼워 넣을 때 들어오는 문이다 (src/utils/embed.ts).
 * 잘 되면 로더가 바로 몰 관리 주소로 보내므로 이 화면은 거의 보이지 않는다. 기다리는 동안의 로딩도 글로벌 소듀가 띄운다.
 * 보이는 것은 토큰을 못 받았거나 운영 중인 몰이 없을 때뿐이다.
 */
export default function EmbedMall() {
    const data = useLoaderData() as { message?: string } | null;
    const { state } = useNavigation();
    const message = data?.message;

    useEffect(() => {
        if (message) announceEmbedShown();
    }, [message]);

    // 들어오는 동안의 로딩은 글로벌 소듀가 띄운다. 여기서는 그리지 않는다
    if (state === 'loading' || !data?.message) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                minHeight: '60vh',
                px: 3,
                textAlign: 'center',
            }}
        >
            <Typography variant="subtitle1" fontWeight={700}>
                {data.message}
            </Typography>
            <Button variant="outlined" sx={{ cursor: 'pointer' }} onClick={() => window.location.reload()}>
                다시 시도
            </Button>
        </Box>
    );
}
